export type AgencyInfo = {
  label: string;
  isInAgency: boolean | null;
  agencyName: string | null;
};

export type PriorityInfo = {
  label: string;
  level: number;
};

export function inferAgencyFromInfluencer(bio?: string | null, username?: string | null): AgencyInfo {
  if (!bio) {
    return { label: "Agence inconnue", isInAgency: null, agencyName: null };
  }

  const emailMatch = bio.match(/([A-Z0-9._%+-]+)@([A-Z0-9.-]+\.[A-Z]{2,})/i);
  if (!emailMatch) {
    return { label: "Agence inconnue", isInAgency: null, agencyName: null };
  }

  const emailUsername = emailMatch[1].toLowerCase().replace(/[._-]/g, "");
  const domain = emailMatch[2].toLowerCase();

  const genericDomains = [
    "gmail.com",
    "gmail.fr",
    "googlemail.com",
    "outlook.com",
    "outlook.fr",
    "live.com",
    "live.fr",
    "hotmail.com",
    "hotmail.fr",
    "msn.com",
    "yahoo.fr",
    "yahoo.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "orange.fr",
    "wanadoo.fr",
    "sfr.fr",
    "neuf.fr",
    "numericable.fr",
    "bbox.fr",
    "bouygtel.fr",
    "free.fr",
    "laposte.net",
  ];

  if (genericDomains.includes(domain)) {
    return {
      label: "Probablement libre",
      isInAgency: false,
      agencyName: null,
    };
  }

  // Check if domain matches username (personal domain like jocelyn@jocelyn.fr)
  const normalizedUsername = username?.toLowerCase().replace(/[._-]/g, "") || "";
  const domainName = domain.split(".")[0].replace(/[._-]/g, "");

  // Only if domain name matches username, it's a personal domain
  if (normalizedUsername && domainName === normalizedUsername) {
    return {
      label: "Probablement libre",
      isInAgency: false,
      agencyName: null,
    };
  }

  // Otherwise, it's likely an agency
  const rawName = domain.split(".")[0].replace(/[-_]/g, " ");
  const agencyName =
    rawName
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ") || "Agence";

  return {
    label: `Agence : ${agencyName}`,
    isInAgency: true,
    agencyName,
  };
}

export function computeRecruitPriority(
  followersCount: number,
  engagementRate: number,
  isInAgency: boolean | null
): PriorityInfo {
  if (isInAgency === true) {
    return { label: "Faible priorité", level: 1 };
  }

  if (followersCount >= 50000 && followersCount <= 400000 && engagementRate >= 3) {
    return { label: "À contacter", level: 5 };
  }

  if (followersCount >= 30000 && engagementRate >= 2) {
    return { label: "À contacter", level: 4 };
  }

  if (followersCount >= 10000 && engagementRate >= 1.5) {
    return { label: "À voir", level: 3 };
  }

  if (followersCount >= 5000) {
    return { label: "Faible priorité", level: 2 };
  }

  return { label: "Très faible priorité", level: 1 };
}
